import { lazy } from 'react';

const list = lazy(() => import('./List'));

export { list };
